module.exports = __webpack_public_path__ + "static/media/te.7f84718b.jpeg";